import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import loginReducer from './login/login.reducer';
import profileReducer from './profile/profile.reducer';
import generalReducer from './general/general.reducer';
import verificationReducer from './verification/verification.reducer';

//User Control Access
import asignUserRightsReducer from './user-controls-access/assign-users-rights/assign-users-rights.reducer';
import memberMandatoryAccessReducer from './user-controls-access/member-mandatory-access/member-mandatory-access.reducer';
import workFlowManagementReducer from './user-controls-access/work-flow-management/work-flow-management.reducer';

import highMarkRulesReducer from './user-controls-access/high-mark-rules/high-mark-rules.reducer';

// Company
import companyReducer from './company/company.reducer';

// Masters
import branchReducer from './master/branch/branch.reducer';
import centerReducer from './master/center/center.reducer';
import staffReducer from './master/staff/staff.reducer';
import roleReducer from './master/role/role.reducer';
import savingsReducer from './master/savings/savings.reducer';
import dashboardReducer from './dashboard/dashboard.reducer';
import insuranceCompanyReducer from './master/insurance-company/insurance-company.reducer';
import purposeofLoanTypeReducer from './master/purpose-of-loan-type/purpose-of-loan-type.reducer';
import productTypeReducer from './master/product-type/product-type.reducer';
import businessfundReducer from './master/business-fund/business-fund.reducer';
import funderReducer from './master/funder/funder.reducer';
import groupReducer from './master/group/group.reducer';
import EconomicActivityReducer from './master/economicActivity/economicActivity.reducer';
import economicActivityTypeReducer from './master/economic-activity-type/economic-activity-type.reducer';
import productReducer from './master/product/product.reducer';
import questionaireReducer from './master/questionaire/questionaire.reducer';
// MASTERS - MEMBER
import memberReducer from './master/member/member.reducer';
import otpVerifyReducer from './master/member-add/verify-otp/verify-otp.reducer';
import aadharDetailsReducer from './master/member-add/aadhar-details/aadhar-details.reducer';
import addMemberReducer from './master/member-add/add-member/add-member.reducer';
import basicDetailsReducer from './master/member-add/basic-details/basic-details.reducer';
import photoVerificationReducer from './master/member-add/photo-verification/photo-verification.reducer';
import signatureReducer from './master/member-add/signature/signature.reducer';
import personalDetailsReducer from './master/member-add/personal-details/personal-details.reducer';
import basicNomineeDetailsReducer from './master/member-add/basic-nominee-details/basic-nominee-details.reducer';
import bankDetailsReducer from './master/member-add/bank-details/bank-details.reducer';
import familyDetailsReducer from './master/member-add/family-details/family-details.reducer';
import houseDetailsReducer from './master/member-add/house-details/house-details.reducer';
import drivingLicenceDetailsReducer from './master/member-add/driving-licence-details/driving-licence-details.reducer';
import pancardDetailsReducer from './master/member-add/pancard-details/pancard-details.reducer';
import passportDetailsReducer from './master/member-add/passport-details/passport-details.reducer';
import rationCardDetailsReducer from './master/member-add/ration-card-details/ration-card-details.reducer';
import addressExtraProofReducer from './master/member-add/address-extra-proof/address-extra-proof.reducer';
import voterIdDetailsReducer from './master/member-add/voter-id-details/voter-id-details.reducer';
import passbookChequeDetailsReducer from './master/member-add/passbook-cheque-details/passbook-cheque-details.reducer';
import housePhotosReducer from './master/member-add/house-photos/house-photos.reducer';
import extraInformationReducer from './master/member-add/extra-infromation/extra-information.reducer';
import officialDetailsReducer from './master/member-add/official-details/official-details.reducer';
import nocPhotosReducer from './master/member-add/noc-photos/noc-photos.reducer';
import residentialDetailsReducer from './master/member-add/residential-details/residential-details.reducer';
import currentAddressReducer from './master/member-add/current-address/current-address.reducer';
import coApplicantReducer from './master/member-add/co-applicant/co-applicant.reducer';
import creditCheckReducer from './master/member-add/credit-check/credit-check.reducer';
import verifyOtpReducer from './master/member-add/verify-otp/verify-otp.reducer';
import advanceMemberReducer from './master/member-add/advance-member/advance-member.reducer';

// OPERATIONS
import auditingToolReducer from './operations/auditing-tool/auditing-tool.reducer';
import commonTransferLogReducer from './operations/common-transfer-log/common-transfer-log.reducer';
import transferCenterReducer from './operations/transfer-center/transfer-center.reducer';
import transferBranchReducer from './operations/transfer-branch/transfer-branch.reducer';
import transferFunderReducer from './operations/transfer-funder/transfer-funder.reducer';
import changeMeetingDateReducer from './operations/change-meeting-date/change-meeting-date.reducer';
import changeGroupOfficerReducer from './operations/change-group-officer/change-group-officer.reducer';
import closeLoanReducer from './operations/close-loan/close-loan.reducer';
import preCloseLoanReducer from './operations/pre-close-loan/pre-close-loan.reducer';
import goldCloseLoanReducer from './operations/gold-close-loan/gold-close-loan.reducer';
import endOfDayReducer from './operations/end-of-day/end-of-day.reducer';
import lastEMIDetailsReducer from './operations/last-emi-details/last-emi-details.reducer';
import closeLoanAdvanceReducer from './operations/close-loan-advance/close-loan-advance.reducer';
import enachDetailsReducer from './operations/nach-umrn-link/nach-umrn-link.reducer';

// OPERATIONS - LOAN PROPOSAL
import centerWiseLoanProposalReducer from './operations/loan-proposal/center-wise-loan-proposal/center-wise-loan-proposal.reducer';
import commonLoanProposalReducer from './operations/loan-proposal/common-loan-proposal/common-loan-proposal.reducer';
import RangeLoanProposalReducer from './operations/loan-proposal/range-product-loan-proposal/range-product-loan-proposal.reducer';
import groupWiseLoanProposalReducer from './operations/loan-proposal/group-wise-loan-proposal/group-wise-loan-proposal.reducer';
import customProductLoanProposalReducer from './operations/loan-proposal/custom-product-loan-proposal/custom-product-loan-proposal.reducer';
import individualLoanProposalReducer from './operations/loan-proposal/individual-loan-proposal/individual-loan-proposal.reducer';
import productLoanProposalReducer from './operations/loan-proposal/product-loan-proposal/product-loan-proposal.reducer';
import goldLoanProposalReducer from './operations/loan-proposal/gold-loan-proposal/gold-loan-proposal.reducer';
import recurringDepositProposalReducer from './operations/loan-proposal/recurring-deposit-proposal/recurring-deposit-proposal.reducer';

// OPERATIONS - COLLECTION
import collectionApproveReducer from './operations/collection/collection-approve/collection-approve.reducer';
import demandCollectionReducer from './operations/collection/demand-collection/demand-collection.reducer';
import advanceCollectionReducer from './operations/collection/advance-collection/advance-collection.reducer';
import arrearCollectionReducer from './operations/collection/arrear-Collection/arrear-Collection.reducer';
import GoldCollectionReducer from './operations/collection/gold-loan-collection/gold-loan-collection.reducer';
import memberCollectionReducer from './operations/collection/member-collection/member-collection.reducer';
import savingCollectionReducer from './operations/collection/saving-collection/saving-collection.reducer';
import fixedDepositReducer from './operations/collection/fixed-deposit/fixed-deposit.reducer';

//  OPERANTONS-LOAN DISBURSEMENT
import loanIndexDisbursementReducer from './operations/loan-disbursement/loan-index-disbursement/loan-index-disbursement.reducer';
import goldLoanDisbursementReducer from './operations/loan-disbursement/gold-loan-disbursement/gold-loan-disbursement.reducer';

// REPORTS
import groupOfficerReportReducer from './reports/group-officer-report/group-officer-report.reducer';
import loanDisbursementReducer from './reports/loan-disbursement/loan-disbursement.reducer';
import requestReportReducer from './reports/request-report/request-report.reducer';
import demandCollectionReportReducer from './reports/demand-collection-report/demand-collection-report.reducer';
import futureDemandReportReducer from './reports/future-demand-report/future-demand-report.reducer';
import memberDetailsReportReducer from './reports/member-details-report/member-details-report.reducer';
import overDueReportReducer from './reports/over-due-report/over-due-report.reducer';
import portfolioAtRiskReducer from './reports/portfolio-at-risk-report/portfolio-at-risk-report.reducer';
import portfolioReportReducer from './reports/portfolio-report/portfolio-report.reducer';
import branchProfileReportReducer from './reports/branch-profile-report/branch-profile-report.reducer';
import loanCardReportReducer from './reports/loan-card-report/loan-card-report.reducer';
import arrearFollowupReportReducer from './reports/arrear-followup-report/arrear-followup-report.reducer';
import dailyCollectionReportReducer from './reports/daily-collection-report/daily-collection-report.reducer';
import walletReportReducer from './reports/wallet-report/wallet-report.reducer';
import thriftReportReducer from './reports/thrift-report/thrift-report.reducer';
import branchCollectionReportReducer from './reports/branch-collection-report/branch-collection-report.reducer';
import closedLoanReportReducer from './reports/closed-loan-report/closed-loan-report.reducer';
import deadMemberReportReducer from './reports/dead-member-report/dead-member-report.reducer';
import precloseLoanReportReducer from './reports/preclose-loan-report/preclose-loan-report.reducer';
import activeMemberReducer from './reports/active-member-report/active-member.reducer';
import changeMeetingReportReducer from './reports/change-meeting-report/change-meeting-report.reducer';
import insuranceReportReducer from './reports/insurance-report/insurance-report.reducer';
import qrReportReducer from './reports/qr-report/qr-report.reducer';
import accountDayBookReportReducer from './reports/day-book-report/day-book-report.reducer';
import branchDCBReportReducer from './reports/branch-DCB-report/branch-DCB-report.reducer';
import demandFollowupReportReducer from './reports/demand-followup-report/demand-followup-report.reducer';
import inActiveMemberReducer from './reports/in-active-member-report/in-active-member.reducer';
import enachReducer from './reports/enach-report/enachReport.reducer';
import mandateReducer from './reports/mandate-report/MandateReport.reducer';
import groupReportReducer from './reports/group-report/group.report.reducer';
import memberRejectionReportReducer from './reports/member-rejection-report/member-rejection-report.reducer';
import attendanceReportReducer from './reports/attendance-report/attendance-report.reducer';
import sanctionReportReducer from './reports/sanction-report/sanction-report.reducer';
import staffReportReducer from './reports/staff-report/staff-report.reducer';
import collectionFormatReportReducer from './reports/collection-format-report/collection-format-report.reducer';
import branchSummaryReducer from './reports/branch-summary-report/branch-summary-report.reducer';
import dealerReportReducer from './reports/dealer-report/dealer-report.reducer';
/******** Temproary Command this - prabananth ********/
import auditTrailReportReducer from './reports/unusedReportRedux/audit-trail-report/audit-trail-report.reducer';

import auditingToolReportReducer from './reports/auditing-tool-report/auditing-tool-report.reducer';
import kycSourcedReportReducer from './reports/kyc-sourced-report/kyc-sourced-report.reducer';
import memberAccountReportReducer from './reports/member-account-report/member-account-report.reducer';
import postAuditingToolReportReducer from './reports/post-auditing-tool-report/post-auditing-tool-report.reducer';
import npaReportReducer from './reports/npa-report/npa-report.reducer';
import memberAttendanceReportReducer from './reports/member-attendance-report/member-attendance-report.reducer';
import repaymentCollectionReportReducer from './reports/repayment-collection-report/repayment-collection-report.reducer';
import progressReportReducer from './reports/progress-report/progress-report.reducer';
import paymentToPayReportReducer from './reports/promise-to-pay-report/promise-to-pay-report.reducer';
import officerLocationReportReducer from './reports/officer-location/officer-location-report.reducer';
import monthWiseInterestSummaryReportReducer from './reports/month-wise-interest-summary-report/month-wise-interest-summary-report.reducer';
import centerDCBReportReducer from './reports/center-DCB-report/center-DCB-report.reducer';

// FINANCE - MASTER
import gstTypeReducer from './finance/master/gstType/gstType.reducer';
import monthlyProgressReducer from './reports/monthly-progress-report/monthly-progress.reducer';
import goldloanInterestReminderReportReducer from './reports/gold-loan-interest-reminder-report/gold-loan-interest-reminder-report.reducer';
import leadReducer from './reports/lead-report/lead-report.reducer';
import goldPriceReducer from './reports/gold-price-report/gold-price-report.reducer';
import goldLoanArrearReportReducer from './reports/gold-loan-arrear-report/gold-loan-arrear-report.reducer';
import goldLoanCollectionReducer from './operations/collection/gold-loan-collection/gold-loan-collection.reducer';
import accountReducer from './finance/master/account/account.reducer';
import accountMappingReducer from './finance/master/account-mapping/account-mapping.reducer';
import journalTransactionReducer from './finance/master/journal-transaction/journal-transaction.reducer';
import groupAccountReducer from './finance/master/groupAccount/groupAccount.reducer';
import subGroupAccountReducer from './finance/master/subGroupAccount/subGroupAccount.reducer';
import OpeningBalanceReducer from './finance/master/opening-balance/opening-balance.reducer';

// Transaction
import cashTransactionReducer from './finance/transaction/common-transaction.reducer';

// FINANCE - MASTER
import ledgerReportReducer from './finance/reports/ledgerReports/LedgerReports.reducer';
import ProfitAndLossReducer from './finance/reports/profitAndLossReport/profit-and-loss.reducer';
import receiptsPaymentsReducer from './finance/reports/receiptsPayments/ReceiptsPayments.reducer';
import TrailBalanceReducer from './finance/reports/trailBalance/trailBalance.reducer';
import InstrumentReducer from './finance/master/instrument/instrument.reducer';
/****************** AUTO LOAN REDUCER START ************************ */
import autoLoanIndexDisbursementReducer from './operations/loan-disbursement/auto-loan-index-disbursement/auto-loan-index-disbursement.reducer';
import autoLoanProposalReducer from './operations/loan-proposal/auto-loan-proposal/auto-loan-proposal.reducer';
import dealerReducer from './master/dealer/dealer.reducer';
import autoLoanCollectionReducer from './operations/collection/auto-loan-collection/auto-loan-collection.reducer';
import bankTransactionReducer from './finance/master/bankTransaction/bankTransaction.reducer';
import balanceSheetReducer from './finance/reports/balance-sheet/balance-sheet.reducer';
import daybookReportReducer from './finance/reports/dayBookReports/daybookReport.reducer';
import funderDetailsReducer from './operations/Funder-Details/funder-details.reducer';
import purposeofLoanReducer from './master/purpose-of-loan/purpose-of-loan.reducer';
import autoLoanCollectionReportReducer from './reports/auto-loan-collection-report/auto-loan-collection-report.reducer';
import businessLoanProposalReducer from './operations/loan-proposal/business-loan-proposal/business-loan-proposal.reducer';
import businessDetailsReducer from './master/business/business-details/business-details.reducer';
import businessBranchDetailsReducer from './master/business/branch-details/branch-details.reducer';
import businessBankDetailsReducer from './master/business/bank-details/bank-details.reducer';
import businessKycVerificationReducer from './master/business/kyc-verification/kyc-verification.reducer';
import businessPartnerDetailsReducer from './master/business/partner-details/partner-details.reducer';
import businessRelatedPartiesReducer from './master/business/related-parties/related-parties.reducer';
import businessProofDetailsReducer from './master/business/proof-details/proof-details.reducer';
import businessVerificationDetailsReducer from './master/business/verification-details/verification-details.reducer';
import businessLoanDisbursementReducer from './operations/loan-disbursement/business-loan-disbursement/business-loan-disbursement.reducer';
import ruleEngineReducer from './user-controls-access/rule-engine/rule-engine.reducer';
import goldLoanCollectionReportReducer from './reports/gold-loan-collection-report/gold-loan-collection-report.reducer';
import goldStockReducer from './reports/gold-stock-report/gold-stock-report.reducer';
import creditBureauReportReducer from './reports/credit-bureau-report/credit-bureau-report.reducer';
import dataVerificationReportReducer from './reports/data-verification-report/data-verification-report.reducer';
import accuredInterestReportReducer from './reports/accured-interest-report/accured-interest-report.reducer';
import savingsFollowupReportReducer from './reports/savings-followup-report/savings-followup.reducer';
import businessCollectionReducer from './operations/collection/business-loan-collection/business-collection.reducer';
import centerWiseReportReducer from './reports/center-wise-report/center-wise-report.reducer';
// import vehicleSeizedReportReducer from './reports/vehicle-seized-report/vehicle-seized-report.reducer';
/****************** AUTO LOAN REDUCER END ************************ */

const persistConfig = {
	key: 'root',
	storage,
	whitelist: ['base_login', 'general'],
};

const rootReducer = combineReducers({
	base_login: loginReducer,
	dashboard: dashboardReducer,
	profile: profileReducer,
	general: generalReducer,
	verification: verificationReducer,

	//User Control Access
	listUserControl_details: asignUserRightsReducer,
	memberMandatoryAccess_details: memberMandatoryAccessReducer,
	WorkFlow_management: workFlowManagementReducer,
	highmark_rules: highMarkRulesReducer,
	rule_engine: ruleEngineReducer,

	// COMPANY
	company_page: companyReducer,

	//MASTERS
	branch_master: branchReducer,
	center_master: centerReducer,
	staff_master: staffReducer,
	role_master: roleReducer,
	savings_master: savingsReducer,
	insurance_company: insuranceCompanyReducer,
	purpose_of_loan: purposeofLoanReducer,
	purpose_of_loan_type: purposeofLoanTypeReducer,
	product_type: productTypeReducer,
	businessfund_master: businessfundReducer,
	funder_master: funderReducer,
	group_master: groupReducer,
	economic_activity: EconomicActivityReducer,
	economic_activity_type: economicActivityTypeReducer,
	product_master: productReducer,
	questionnaire: questionaireReducer,
	business_details: businessDetailsReducer,
	branch_details: businessBranchDetailsReducer,
	bank_details: businessBankDetailsReducer,
	kycverification_details: businessKycVerificationReducer,
	partner_details: businessPartnerDetailsReducer,
	proof_details: businessProofDetailsReducer,
	parties_details: businessRelatedPartiesReducer,
	verify_details: businessVerificationDetailsReducer,

	// MASTERS - MEMBER
	member_master: memberReducer,
	otp_verify: otpVerifyReducer,
	aadhar_details: aadharDetailsReducer,
	fetch_member: addMemberReducer,
	basic_details: basicDetailsReducer,
	photo_verify: photoVerificationReducer,
	upload_signature: signatureReducer,
	personal_details: personalDetailsReducer,
	family_details: familyDetailsReducer,
	nominee_details: basicNomineeDetailsReducer,
	member_bank_details: bankDetailsReducer,
	house_details: houseDetailsReducer,
	driving_licence: drivingLicenceDetailsReducer,
	pancard_details: pancardDetailsReducer,
	passport: passportDetailsReducer,
	ration_card_details: rationCardDetailsReducer,
	voter_Id_details: voterIdDetailsReducer,
	address_extra_proof: addressExtraProofReducer,
	passbook_cheque_details: passbookChequeDetailsReducer,
	house_photos: housePhotosReducer,
	extra_information: extraInformationReducer,
	official_details: officialDetailsReducer,
	noc_photos: nocPhotosReducer,
	residential_details: residentialDetailsReducer,
	current_address: currentAddressReducer,
	co_applicant: coApplicantReducer,
	credit_check_details: creditCheckReducer,
	verify_otp: verifyOtpReducer,
	AdvanceMember: advanceMemberReducer,

	// OPERATIONS
	auditing_tool: auditingToolReducer,
	funder_details: funderDetailsReducer,
	CloseLoan_member: closeLoanReducer,
	pre_close_loan: preCloseLoanReducer,
	GoldCloseLoan_member: goldCloseLoanReducer,
	common_transfer_log: commonTransferLogReducer,
	transfer_center: transferCenterReducer,
	transfer_branch: transferBranchReducer,
	transfer_funder: transferFunderReducer,
	EndOfDayDetails: endOfDayReducer,
	change_meeting_date: changeMeetingDateReducer,
	change_group_officer: changeGroupOfficerReducer,
	last_EMI_Details: lastEMIDetailsReducer,
	close_loan_advance: closeLoanAdvanceReducer,
	ENACH_Details: enachDetailsReducer,

	// OPERATIONS - LOAN PROPOSAL
	center_wise_loan_proposal: centerWiseLoanProposalReducer,
	common_loan_proposal: commonLoanProposalReducer,
	range_loan_proposal: RangeLoanProposalReducer,
	group_wise_loan_proposal: groupWiseLoanProposalReducer,
	custom_product_loan_proposal: customProductLoanProposalReducer,
	individual_loan_proposal: individualLoanProposalReducer,
	product_loan_proposal: productLoanProposalReducer,
	gold_loan_proposal: goldLoanProposalReducer,
	recurring_deposit_proposal: recurringDepositProposalReducer,

	// OPERATIONS - COLLECTION
	collection_approval: collectionApproveReducer,
	demandCollection: demandCollectionReducer,
	advanceCollection: advanceCollectionReducer,
	arrearCollection: arrearCollectionReducer,
	goldCollection: GoldCollectionReducer,
	memberCollection: memberCollectionReducer,
	savingCollection: savingCollectionReducer,
	fixedDeposit_Details: fixedDepositReducer,
	businessCollection: businessCollectionReducer,

	// OPERATION - DISBURSEMENT
	loan_index_disbursement: loanIndexDisbursementReducer,
	business_loan_disbursment: businessLoanDisbursementReducer,
	gold_loan_disbursement: goldLoanDisbursementReducer,
	demand_collection: demandCollectionReportReducer,

	// REPORTS
	loan_disbursement: loanDisbursementReducer,
	request_report: requestReportReducer,
	future_demand_report: futureDemandReportReducer,
	member_details_report: memberDetailsReportReducer,
	overdue_report: overDueReportReducer,
	portfolio_at_risk_report: portfolioAtRiskReducer,
	portfolio_report: portfolioReportReducer,
	arrear_followup: arrearFollowupReportReducer,
	branch_profile_report: branchProfileReportReducer,
	loan_card_report: loanCardReportReducer,
	daily_collection_report: dailyCollectionReportReducer,
	branch_DCB_Report: branchDCBReportReducer,
	account_Day_Book_Report: accountDayBookReportReducer,
	demand_followup: demandFollowupReportReducer,
	wallet_report: walletReportReducer,
	thrift_report: thriftReportReducer,
	branch_collection_report: branchCollectionReportReducer,
	closed_loan_details: closedLoanReportReducer,
	openingBalance_finance: OpeningBalanceReducer,
	dead_member_details: deadMemberReportReducer,
	preclose_report: precloseLoanReportReducer,
	active_member: activeMemberReducer,
	inactive_member: inActiveMemberReducer,
	change_meeting: changeMeetingReportReducer,
	insurance_report: insuranceReportReducer,
	ENACHReport: enachReducer,
	MandateReport: mandateReducer,
	QR_Report: qrReportReducer,
	group_report: groupReportReducer,
	memberRejectionReport: memberRejectionReportReducer,
	attendance_report: attendanceReportReducer,
	sanction_report: sanctionReportReducer,
	Staff_Details: staffReportReducer,
	autoLoan_Collection_Report_page: autoLoanCollectionReportReducer,
	business_loan_proposal: businessLoanProposalReducer,
	savings_followup_report: savingsFollowupReportReducer,
	audit_trail_report: auditTrailReportReducer,
	collection_format_report: collectionFormatReportReducer,

	monthly_progress: monthlyProgressReducer,
	auditing_tool_report: auditingToolReportReducer,
	kyc_sourced_report: kycSourcedReportReducer,
	member_account_report: memberAccountReportReducer,
	post_Auditing_Tool_Report: postAuditingToolReportReducer,
	goldloanInterestReminderReport: goldloanInterestReminderReportReducer,
	LeadReport: leadReducer,
	gold_price_report: goldPriceReducer,
	gold_loan_arrear_report: goldLoanArrearReportReducer,
	gold_loan_collection: goldLoanCollectionReducer,
	NPA_report: npaReportReducer,
	member_Attendance_Report: memberAttendanceReportReducer,
	repayment_collection_report: repaymentCollectionReportReducer,
	progress_report: progressReportReducer,
	promise_to_pay_report: paymentToPayReportReducer,
	month_wise_interest_report: monthWiseInterestSummaryReportReducer,
	group_officer_report: groupOfficerReportReducer,
	officer_location: officerLocationReportReducer,
	gold_loan_collection_report: goldLoanCollectionReportReducer,
	center_DCB_Report: centerDCBReportReducer,
	gold_stock: goldStockReducer,
	BranchSummary_report: branchSummaryReducer,
	center_wise_report: centerWiseReportReducer,
	// vehicle_seized_report: vehicleSeizedReportReducer,
	dealer_report: dealerReportReducer,

	// FINANCE - MASTER
	GSTType_finance: gstTypeReducer,
	account_page: accountReducer,
	accountMapping_finance: accountMappingReducer,
	journalTransaction_finance: journalTransactionReducer,
	GroupAccount_finance: groupAccountReducer,
	SubGroupAccount_finance: subGroupAccountReducer,
	instrument: InstrumentReducer,
	bank_transaction_page: bankTransactionReducer,

	// Transaction
	CashTransaction_finance: cashTransactionReducer,

	// FINANCE - REPORTS
	ledgerReports_finance: ledgerReportReducer,
	profitAndLoss_finance: ProfitAndLossReducer,
	receiptsPayments_finance: receiptsPaymentsReducer,
	balance_sheet_report: balanceSheetReducer,
	daybook_report_page: daybookReportReducer,
	TrailBalance_finance: TrailBalanceReducer,

	// AUTO LOAN
	auto_loan_collection: autoLoanCollectionReducer,
	auto_loan_disbursement: autoLoanIndexDisbursementReducer,
	auto_loan_proposal: autoLoanProposalReducer,
	dealer_master: dealerReducer,
	credit_bureau_report: creditBureauReportReducer,
	data_verification_report: dataVerificationReportReducer,
	AccuredInterest_report: accuredInterestReportReducer,
});

// @ts-ignore
export default persistReducer(persistConfig, rootReducer);
